export const convertToCentimeters = (value) => {
  return value / 10;
};

export const convertToMillimeters = (value) => {
  return parseFloat(value) * 10;
};
